/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AssetPreview from 'shared/ui/components/uploader/AssetPreview.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Draggable from 'vuedraggable';

const __vue_script__ = {
    name: 'ExternalPicker',

    components: { AssetPreview, BaseSelect, Draggable },

    extends: BaseControl,

    props: {
        value: {
            type: [Array, String],
            default: () => []
        },

        options: {
            type: Array,
            default: () => []
        },

        fpType: {
            type: String,
            required: true
        },

        sortable: {
            type: Boolean,
            default: true
        },

        loading: {
            type: Boolean,
            default: false
        },

        emitKey: {
            type: String,
            default: 'fp_ext_id'
        },

        timezone: {
            type: String,
            default: undefined
        },

        emitObjects: {
            type: Boolean,
            default: false
        },

        multiple: {
            type: Boolean,
            default: false
        },

        preview: {
            type: Boolean,
            default: false
        },

        eventId: {
            type: String,
            default: null
        },
    },

    data() {
        return {
            attrs: {},
            showPreview: false
        };
    },

    computed: {
        valueIds() {
            const isValueAnArray = Array.isArray(this.value);
            let ids;
            if (isValueAnArray) {
                if (this.value[0] instanceof Object) {
                    ids = this.value.map(v => v[this.emitKey]);
                } else {
                    // Must be an array of strings
                    ids = this.value;
                }
            } else {
                ids = this.value instanceof Object ? [this.value[this.emitKey]] : [this.value];
            }

            return ids || [];
        },

        innerValue: {
            get() {
                if (typeof this.value === 'string') {
                    return this.options.find(o => o[this.emitKey] === this.value) || this.value;
                }

                return this.value || [];
            },

            set(value) {
                this.emit(value);
            }
        }
    },

    watch: {
        $attrs: {
            immediate: true,
            handler() {
                this.attrs = { ...this.$options.propsData, ...this.$attrs };
                if (!this.attrs.hasOwnProperty('hide-selected')) {
                    this.attrs['hide-selected'] = true;
                }
            }
        },

        options: {
            immediate: true,
            handler() {
                if (!this.options?.length) {
                    return;
                }

                if (this.valueIds?.length && this.emitKey) {
                    const scannedDocs = this.options.find(o => this.valueIds.includes(o[this.emitKey]));

                    if (scannedDocs?.length) {
                        this.innerValue = scannedDocs;
                    }
                }
            }
        }
    },

    methods: {
        /**
         * Given a document this method returns the proper label
         *
         * @param {object|string} item the document or its label
         *
         * @returns {string} the item label
         */
        getItemLabel(item) {
            if (typeof item === 'string') {
                item = this.options.find(o => o[this.emitKey] === item) || { label: item };
            }

            const date = item.timestamp ? `[${this.getItemDateAndTime(item)}] ` : '';
            const label = this.$utils.locales.translateWithContext(item.label || item[this.emitKey], item, this.$i18n);

            return `${date}${label}`;
        },

        /**
         * Given a document this method returns the date frmatted in human form
         *
         * @param {object} item the document
         *
         * @returns {string} the formatted date
         */
        getItemDateAndTime(item) {
            return item.timestamp ? this.$utils.time.convertTimestampToHumanForm(item.timestamp, this.timezone) : '';
        },

        /**
         * @param {string} query the search term
         */
        emitSearch(query) {
            this.$emit('search', query);
        },

        emitOpen() {
            this.$emit('open');
        },

        /**
         * Removes a document from the set
         *
         * @param {object} doc the document to remove
         */
        remove(doc) {
            if (this.disabled) {
                return;
            }
            this.innerValue = this.innerValue.filter(d => d[this.emitKey] !== doc[this.emitKey]);
        },

        /**
         * Emits the documents set
         */
        emit(value) {
            if (!value || this.emitObjects) {
                this.$emit('input', value);
            } else if (this.multiple) {
                this.$emit('input', value.map(d => d[this.emitKey]));
            } else {
                this.$emit('input', value[this.emitKey]);
            }
        }

    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external-picker"},[_c('base-select',_vm._b({attrs:{"clear-on-select":false,"close-on-select":!_vm.multiple,"custom-label":_vm.getItemLabel,"disabled":_vm.disabled,"errors":_vm.errors,"internal-search":false,"loading":_vm.loading,"options":_vm.options,"preserve-search":true,"blockKeys":['Delete'],"track-by":_vm.emitKey},on:{"open":_vm.emitOpen,"search-change":_vm.emitSearch},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var values = ref.values;
var search = ref.search;
var isOpen = ref.isOpen;
return [(values.length)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!isOpen),expression:"!isOpen"}],staticClass:"multiselect__single"},[_vm._v(_vm._s(_vm.$tc('generic_form.external_picker.options_selected', values.length, [values.length])))]):_vm._e()]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('div',{staticClass:"option"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.getItemLabel(option)))]),_vm._t("option",null,{"option":option})],2)]}},{key:"control-actions",fn:function(ref){return [_vm._t("control-actions")]}}],null,true),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'base-select',_vm.attrs,false)),(_vm.multiple && _vm.innerValue.length)?[(_vm.sortable)?_c('draggable',{staticClass:"documents",on:{"end":function($event){return _vm.emit(_vm.innerValue)}},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},_vm._l((_vm.innerValue),function(doc){return _c('div',{key:doc[_vm.emitKey],staticClass:"doc sortable"},[_c('div',{staticClass:"details"},[_c('i',{staticClass:"ic-menu drag",attrs:{"tabindex":"0"}}),_c('i',{staticClass:"type",class:_vm.$utils.assets.getIconForType(_vm.fpType)}),(doc.timestamp)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.getItemDateAndTime(doc)))]):_vm._e(),(doc.badge)?_c('span',{staticClass:"badge",class:doc.badge_classes},[_vm._v(_vm._s(doc.badge))]):_vm._e(),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.getItemLabel(doc)))]),_vm._t("document-item-subtitle",null,{"doc":doc})],2)]),_vm._t("document",null,{"doc":doc}),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"remove has-action",class:{ disabled: _vm.disabled },attrs:{"href":"#"},on:{"click":function($event){return _vm.remove(doc)}}},[_c('i',{staticClass:"ic-x"})])])],2)}),0):_c('div',{staticClass:"documents"},_vm._l((_vm.innerValue),function(doc){return _c('div',{key:doc[_vm.emitKey],staticClass:"doc"},[_c('div',{staticClass:"details"},[_c('i',{staticClass:"type",class:_vm.$utils.assets.getIconForType(_vm.fpType)}),(doc.timestamp)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.getItemDateAndTime(doc)))]):_vm._e(),(doc.badge)?_c('span',{staticClass:"badge",class:doc.badge_classes},[_vm._v(_vm._s(doc.badge))]):_vm._e(),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.getItemLabel(doc)))]),_vm._t("document-item-subtitle",null,{"doc":doc})],2)]),_vm._t("document",null,{"doc":doc}),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"remove has-action",class:{ disabled: _vm.disabled },attrs:{"href":"#"},on:{"click":function($event){return _vm.remove(doc)}}},[_c('i',{staticClass:"ic-x"})])])],2)}),0)]:(_vm.innerValue.length)?[_vm._t("document",null,{"doc":_vm.innerValue[0]})]:_vm._e(),(_vm.preview && _vm.innerValue.length)?[_vm._l((_vm.innerValue),function(innerItem){return [(innerItem._id)?_c('asset-preview',{attrs:{"item":{ asset: innerItem.fp_asset, _id: innerItem._id },"cell":{ field: 'asset' },"event":{ _id: _vm.eventId }}}):_vm._e()]})]:_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ExternalPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__